module.exports = __webpack_public_path__ + "img/calendar-icon.dcd84ea8.png";